import React, { Component, useState } from 'react';
import DrawerCustom from '../../components/DrawerCustom';
import ButtonCustom from '../../components/ButtonCustom';
import { withTranslation } from 'react-i18next';
import { withStyles } from '@material-ui/core/styles';
import Typo from '../../components/CustomTypo';
import { Grid, Menu, ListItem, ListItemIcon, ListItemText, Button, TextField } from '@material-ui/core';
import { dataUtil, usage_type } from '../../wsclient/crmservices/dataUtil';
import { TimeIcon, BackIcon, MopedIcon, PlaceIcon, PhoneIcon, EditWhiteIcon, EditWhiteSmallIcon } from '../../components/icons'
import GoogleMapComponent from '../../components/GoogleMapComponent';
import GoogleMapMarker from '../../components/GoogleMapMarker';
import Divider from '../../components/Divider'
import { formatTimeFrEpoch } from '../../utils/util';
import {MuiPickersUtilsProvider, TimePicker, KeyboardTimePicker, KeyboardDateTimePicker} from '@material-ui/pickers';
import MomentUtils from "@date-io/moment";
import { Field, Form } from 'react-final-form';
import { TimePickerComponent } from '../../components/FormElement';
import Container from '../../components/Container';
const styles = theme => ({
    container: {
        padding: theme.spacing(5, 4, 5, 4)
    },
    paddingLeft: {
        paddingLeft: theme.spacing(13)
    },
    button: {
        padding: theme.spacing(5, 2, 5, 2)
    },
    buttonBack: {
        width: theme.spacing(10),
        height: theme.spacing(10),
        backgroundColor: theme.palette.background.secondary,
        borderRadius: theme.spacing(8),
        cursor: "pointer",
        textAlign: "center",
        touchAction: "manipulation",
        position: 'absolute',
        top: theme.spacing(5),
        right: theme.spacing(5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    content: {
        marginTop: theme.spacing(20)
    },
    footer: {
        position: 'absolute',
        bottom: theme.spacing(5),
        width: '90%'
    },
    item_image: {
        width: 50,
        height: 50,
        objectFit: 'containt',
        borderRadius: 50,
    },
    item_image_container: {
        width: 60,
        height: 60,
        borderRadius: 60,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5),
        backgroundColor: theme.palette.background.secondary,
    },
    item_icon_container: {
        marginLeft: 10,
        width: 40,
        height: 40,
        borderRadius: 40,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginRight: theme.spacing(5) + 10,
        backgroundColor: theme.palette.button.category.backgroundColor,
    },
    item: {
        // padding: theme.spacing(0,5,0,5),
        margin: theme.spacing(5, 0, 5, 0),
    },
    listItemIconRoot: {
        minWidth: theme.spacing(9)
    },
    timePicker: {
        minWidth: theme.spacing(9),
        width:'100%',
        color:theme.palette.input.secondary,
        margin: theme.spacing(-5,0,-3,0),
    },
    edit:{
        cursor:'pointer', 
        marginRight:theme.spacing(2), 
        marginTop: theme.spacing(1)
    }
})

function PlaceOrderView(props) {
        
    const { classes, t, open, onChangeTime,onClose, estimate_order_result, delivery_address, pick_up_store, order_type, contact_phone, showPhoneValidation, auth_support } = props;
    var estimated_delivery = estimate_order_result.order_estimate && estimate_order_result.order_estimate.estimated_delivery ? estimate_order_result.order_estimate.estimated_delivery : null;
    var delivered_by = estimate_order_result && estimate_order_result.order_estimate && estimate_order_result.order_estimate.fulfilled_by
        ? estimate_order_result.order_estimate.fulfilled_by.name : "";
        const delivery_at = estimated_delivery&&estimated_delivery.delivered_at? estimated_delivery.delivered_at : null;
        //console.log('pick_up_store====',pick_up_store)
        var pickup_address = pick_up_store && pick_up_store.address ? pick_up_store.address.address_line_1
        + (pick_up_store.address.town_city ? ', ' + pick_up_store.address.town_city : '')
        + (pick_up_store.address.state_province_county ? ', ' + pick_up_store.address.state_province_county : '')
        + (pick_up_store.address.postal_code ? ', ' + pick_up_store.address.postal_code : '')
        : ''
    return (
        <Container showLoading={props.waitSelelectTime}>
        <DrawerCustom large open={open} onClose={onClose} fullScreen>
            <Grid xs={12} item>
                <Grid xs={12} item style={{ height: '40%' }}>
                    <OrderMap
                        delivery_address={delivery_address}
                        pick_up_store={pick_up_store}
                        order_type={order_type}
                    />
                </Grid>
                <Grid xs={12} item className={classes.container}>
                    <Typo color="onPrimary" variant="subtitle1" mg_left_md mg_top_lg>{t("about_order")}</Typo>
                    {order_type === 'DELIVERY' && <ListItem alignItems="flex-start">
                        <ListItemIcon className={classes.listItemIconRoot}>
                            <PlaceIcon />
                        </ListItemIcon>
                        <ListItemText>
                            <Typo color="onPrimary" variant="body2">{t('order_to_be_fulfilled_by')}</Typo>
                            <Typo mg_top_xs color="default" variant="body2">{delivered_by}</Typo>
                        </ListItemText>
                    </ListItem>}
                    {order_type === 'DELIVERY' && <Divider variant="inset" component="li" />}
                    <ListItem alignItems="flex-start">
                        <ListItemIcon className={classes.listItemIconRoot}>
                            <PhoneIcon />
                        </ListItemIcon>
                        <ListItemText >
                            <Typo color={showPhoneValidation?"error":"default"} variant="body2">{contact_phone && contact_phone.number ? contact_phone.number : "Please add phone number"}</Typo>
                        </ListItemText>
                        {auth_support && auth_support.email_password&&
                            <Grid item xs={1} container justify='flex-end' className={classes.edit} onClick={props.onGoToProfile}>
                                <EditWhiteIcon/>
                            </Grid>}
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem alignItems="flex-start">
                        <ListItemIcon className={classes.listItemIconRoot}>
                            {order_type == 'DELIVERY' ? <MopedIcon /> : <PlaceIcon />}
                        </ListItemIcon>
                        {order_type == 'DELIVERY' ? <ListItemText>
                            <Typo color="default" variant="body2">{delivery_address.address_line_1}</Typo>
                        </ListItemText> :
                            <ListItemText>
                                <Grid item xs={12} container >
                                <Grid item xs={8}>
                                <Typo color="onPrimary" variant="body2">{pick_up_store.name}</Typo>
                                <Typo color="default" variant="body2">{pickup_address}</Typo>
                                </Grid>
                                <Grid item xs={4} container alignItems='center' justify='flex-end'>
                                <PhoneIcon/>
                                <Typo color="default" variant="body2" mg_left_md mg_right_xl>{pick_up_store.phone?pick_up_store.phone:''}</Typo>
                                </Grid>
                                </Grid>
                            </ListItemText>}
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    {estimated_delivery&&<Grid item><ListItem alignItems="flex-start" >
                        <ListItemIcon className={classes.listItemIconRoot}>
                            <TimeIcon />
                        </ListItemIcon>
                        <ListItemText>
                            {/* <Typo color="onPrimary" variant="body2">{order_type === 'DELIVERY' ? t('expected_delivery_time') : t('expected_preparation_time')}</Typo> */}
                            {/* <Typo mg_top_xs color="default" variant="body2">{deliveredAt ? deliveredAt + " (" + time_to_deliver + ")" : time_to_deliver}</Typo> */}
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <Grid item xs={12}>
                                        <KeyboardTimePicker
                                        fullWidth
                                        margin="normal"
                                        id="time-picker"
                                        value={props.timeSelected?props.timeSelected: delivery_at*1000}
                                        onChange={onChangeTime}
                                        format={"DD/MM/YYYY HH:MM A"}
                                        KeyboardButtonProps={{
                                            //'aria-label': 'change time',
                                        }}
                                        InputProps={{
                                            disableUnderline: true,
                                            classes: { root: classes.timePicker },
                                                }}
                                        keyboardIcon={<EditWhiteSmallIcon/>}
                                        />
                                    </Grid>
                                </MuiPickersUtilsProvider>
                        </ListItemText>
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    </Grid>}
                </Grid>
                <Grid xs={10} item container direction="row" className={classes.paddingLeft}>
                    <Grid item xs={6} className={classes.button}>
                        <ButtonCustom fullWidth color='primary' onClick={props.processOrder}>{t('btn_process')}</ButtonCustom>
                    </Grid>
                    <Grid item xs={6} className={classes.button}>
                        <ButtonCustom fullWidth color='info' onClick={() => props.onGoBack('cart')}>{t('btn_cancel')}</ButtonCustom>
                    </Grid>

                </Grid>

            </Grid>
        </DrawerCustom>
        </Container>
    )
}
function OrderMap(props) {
    const { delivery_address, pick_up_store, order_type } = props;
    return (
        <GoogleMapComponent>
            <GoogleMapMarker
                info={{ title: order_type == 'DELIVERY' ? delivery_address.address_line_1 : pick_up_store.name, description: order_type == 'DELIVERY' ? "" : (pick_up_store.address?pick_up_store.address.address_line_1:' ') }}
                key={1}
                lat={order_type == 'DELIVERY' ? delivery_address.lat : (pick_up_store.address?pick_up_store.address.lat:null)}
                lng={order_type == 'DELIVERY' ? delivery_address.lon : (pick_up_store.address?pick_up_store.address.lon:null)}
            />
        </GoogleMapComponent>
    )
}

export default withStyles(styles)(withTranslation()(PlaceOrderView))